import {
	AutocompleteInput,
	BooleanInput,
	Create,
	maxValue,
	minValue,
	NumberInput,
	ReferenceInput,
	required,
	SimpleForm,
	TextInput,
} from "react-admin";

export const ReferralLinkCreate = () => (
	<Create>
		<SimpleForm>
			<TextInput
				source="code"
				validate={required()}
				fullWidth
				helperText="Unique referral code"
			/>
			<ReferenceInput source="appId" reference="apps">
				<AutocompleteInput
					optionText="name"
					validate={required()}
					label="App"
					filterToQuery={(q) => ({ name: q })}
				/>
			</ReferenceInput>
			<ReferenceInput source="partnerId" reference="partners">
				<AutocompleteInput
					optionText="name"
					validate={required()}
					label="Partner"
					filterToQuery={(q) => ({ name: q })}
				/>
			</ReferenceInput>
			<NumberInput
				source="commissionPercent"
				label="Commission %"
				validate={[required(), minValue(0), maxValue(100)]}
				defaultValue={10}
			/>
			<NumberInput
				source="attributionWindowDays"
				label="Attribution Window (days)"
				helperText="Leave empty to use app default"
			/>
			<BooleanInput source="active" defaultValue={true} />
		</SimpleForm>
	</Create>
);
